module.exports = __webpack_public_path__ + "static/xeneco_mediaintegrator_background-ecf84e3ade384c0b11d949c9370db562.jpg";